itsoftApp.createModule("ifIE", function() {

    function getInternetExplorerVersion(){
                  var rv = -1;
                  if (navigator.appName == 'Microsoft Internet Explorer')
                  {
                    var ua = navigator.userAgent;
                    var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                    if (re.exec(ua) != null)
                      rv = parseFloat( RegExp.$1 );
                  }
                  else if (navigator.appName == 'Netscape')
                  {
                    var ua = navigator.userAgent;
                    var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
                    if (re.exec(ua) != null)
                      rv = parseFloat( RegExp.$1 );
                  }
                  return rv;
                }

    if(getInternetExplorerVersion()!==-1){
      // $("*[data-src]").css({"opacity":"1"});
      $(".map-picture").hide();
      $(".map-svg").css({"height":"90vmin"});
      $("*[data-src]").attr("src", function(){
          return $(this).attr("data-src");
      });
    }

});
